import ApiRequest from '../api/request';

class SiteManager {
  /* eslint-disable-next-line no-use-before-define */
  static singleton: SiteManager | null = null;

  #_components: Map<any, any> | null = null;

  #_pages: Map<any, any> | null = null;

  #_pageNames: string[] = [];

  #apiToken: string | undefined;

  #_navData = null;

  static GetInstance() {
    // Initialize and load styles
    if (SiteManager.singleton == null) {
      SiteManager.singleton = new SiteManager();
    }
    return SiteManager.singleton;
  }

  async init(apiToken: string | undefined) {
    this.#apiToken = apiToken;
    try {
      const response = await ApiRequest.sendRequest({
        method: 'post',
        params: {},
        path: 'site/init',
        token: this.#apiToken,
      });
      if (response.data.error) {
        console.log(response);
        console.error(`SiteManager.init error: ${response.data.error}`);
        return false;
      }

      const componentMap = new Map();
      let fields = null;
      let field = null;
      let componentName = '';

      // Build set of {K: Component, V: {fields: Map(), properties: Properties}}
      for (let i = 0; i < response.data.components.length; i++) {
        componentName = response.data.components[i].name;
        fields = response.data.components[i].fields;

        if (!componentMap.has(componentName)) {
          componentMap.set(componentName, {
            fields: new Map(),
            properties: response.data.components[i].properties,
          });
        }

        // BUild set of {K: FieldName, V: Field}
        for (let j = 0; j < fields.length; j++) {
          field = fields[j];
          const existingFieldSet = componentMap.get(componentName);
          existingFieldSet.fields.set(field.name, field);
          componentMap.set(componentName, existingFieldSet);
        }
      }

      // Build set of {K: PageName, V: PageModel }
      const pageMap = new Map();
      for (let i = 0; i < response.data.pages.length; i++) {
        if (!pageMap.has(response.data.pages[i].name)) {
          pageMap.set(response.data.pages[i].name, response.data.pages[i]);
          this.#_pageNames.push(response.data.pages[i].name);
        }
      }
      this.#_components = componentMap;
      this.#_pages = pageMap;
      return true;
    } catch (err) {
      console.error(err);
      console.log(`SiteManager.init error: ${err}`);
      return false;
    }
  }

  /** Method to retrieve data from backend and store it here as
        Format: map{key: component, value: map{key: fieldName, value: field }}
        Have fields setup to use styled-components and retrieve their colors from this class
      */
  getColorFor = (componentName: string, fieldName: string) => {
    if (!this.#_components) {
      console.warn(`SiteManager.getColorFor(${componentName}, ${fieldName}) was unloadable\n`);
      return '#FF0000;';
    }
    if (this.#_components.get(componentName) === undefined) {
      console.warn(`SiteManager.getColorFor(${componentName}) could not locate component\n`);
      return '#FF0000;';
    }
    if (this.#_components.get(componentName).fields.get(fieldName) === undefined) {
      console.warn(
        `SiteManager.getColorFor(${componentName}, ${fieldName}) could not locate field\n`,
      );
      return '#FF0000;';
    }
    return this.#_components.get(componentName).fields.get(fieldName).color;
  };

  getComponent = (componentName: string) => {
    if (!this.#_components) {
      console.warn(`SiteManager.getComponent(${componentName}) was unloadable\n`);
      return null;
    }
    if (this.#_components.get(componentName) === undefined) {
      console.warn(`SiteManager.getComponent(${componentName}) could not locate component\n`);
      return null;
    }
    return this.#_components.get(componentName);
  };

  getPageData = (page: string) => this.#_pages?.get(page);

  getPageNames = () => this.#_pageNames;

  setNavData = (navData: any) => {
    this.#_navData = navData;
  };

  getNavData = () => this.#_navData;
}

export default SiteManager;
